module.exports = __webpack_public_path__ + "static/img/1-2.0fca2f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/1-2.png
// module id = sTWY
// module chunks = 0